import { observable } from "mobx";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";

import {
  apiPostClinicalStudiesAdminProcedure,
  apiPutClinicalStudiesAdminProcedureUuid,
  VisitAdminProcedure,
} from "../../../api";
import { Checkbox } from "../../../components/ui-kit/fields/checkbox";
import { dateTimeStrToDateStr } from "../../../utils/utils";
import { Patient } from "../patient";
import { Submittable } from "./base-data-visit-field";

export const AdminDataVisitField = observer(
  function AdminDataVisitField(props: {
    prefill: VisitAdminProcedure;
    patient: Patient;
    ref: (h: Submittable) => void;
    visitUuid: string;
    visitDatetime: string;
  }) {
    const [draft] = useState(() =>
      observable({
        checked: props.prefill.associated_data?.procedure_done ?? false,
      }),
    );

    useEffect(() => {
      const h: Submittable = {
        submit: async () => {
          if (props.prefill.associated_data) {
            if (
              draft.checked === props.prefill.associated_data.procedure_done
            ) {
              return;
            }

            await apiPutClinicalStudiesAdminProcedureUuid({
              path: { uuid: props.prefill.associated_data.uuid },
              body: { procedure_done: draft.checked },
            });

            return;
          }

          if (draft.checked) {
            await apiPostClinicalStudiesAdminProcedure({
              body: {
                number_of_datapoints: 1,
                admin_procedures: [
                  {
                    patient_id: props.patient.patientId,
                    procedure: props.prefill.data_definition.procedure,
                    study_visit_uuid: props.visitUuid,
                    // The visit's own date, not today: a visit is routinely
                    // filled in after the fact, and the API rejects a
                    // procedure dated more than three days from its visit.
                    procedure_date: dateTimeStrToDateStr(props.visitDatetime),
                    procedure_done: true,
                  },
                ],
              },
            });
          }
        },
      };
      props.ref(h);
    }, [props, draft]);

    return <Checkbox attr="checked" model={draft} />;
  },
);
